import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, map, merge, startWith, switchMap } from 'rxjs';
import { CampaignService } from 'src/app/private/services/campaign.service';
import { ManageCampaignService } from 'src/app/private/services/manage-campaign.service';
import { TicketService } from 'src/app/private/services/ticket.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import {
  getLeadSourceImg as resolveLeadSourceImg,
  isLeadSourceImage,
} from 'src/app/utils/lead-source-icon.util';

@Component({
  selector: 'app-campaign-report-details',
  templateUrl: './campaign-report-details.component.html',
  styleUrls: ['./campaign-report-details.component.scss']
})
export class CampaignReportDetailsComponent {
  title = "Todays Leads";
  slug: string = '';

  isLoading = false;
  totalRows = 0;
  pageSize = 25;
  currentPage = 0;
  pageSizeOptions: number[] = [10, 25, 50];
  isDataLoading = false;
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  startDate: any = new Date();
  endDate: any = new Date();

  isOpen = false;

  filterLoading = false;

  selecteTodayFilter: any = "Today";

  selectedCampaignStatus: any[] = ["Draft", "Scheduled", "Pending", "Completed"];
  selectedCampaignType: any[] = ["Email", "WhatsApp"];



  selectedLeadSource: any[] = ["Tina"]

  selectedLeadOwnership: any[] = [];

  ownerList: any[] = [];

  selectedTicketForActivity: any = {};
  hoverIndex: any = -1;



  defaultSetting = {
    singleSelection: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  leadWonerSetting = {
    singleSelection: false,
    idField: 'user_id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  leadStatusList: any[] = [
    "New",
    "Active",
    "Pipeline /Budgetary",
    "Contacted",
    "Qualified",
    "Converted",
    "Closed - Lost",
    "Closed - Won",
    "Follow-up",
    "Not Interested",
    "Duplicate",
    "Disqualified",
    "Marketing Qualified Lead (MQL)",
    "Sales Qualified Lead (SQL)",
  ]


  statusList: any[] = [
    "Draft",
    "Schedule",
    "Pending",
    "Completed"
  ]

  leadSourceList: any[] = [
    "Tina",
    "WhatsApp",
    "Manual",
  ]

  campaignTypeList: any[] = [
    "Email",
    "WhatsApp",
    "Call",
  ]




  displayedColumns: string[] = ["campaign_name", "campaign_type","campaign_group", "campaign_date", "is_schedule", "schedule_date", "schedule_time", "status",];

  priorityList: any[] = [
    "High",
    "Normal",
    "Low",
    "Urgent",
  ]

  isAdmin: boolean = false;


  todaysFilter: any[] = [];

  initialLoad = true;
  constructor(private route: ActivatedRoute,
    private api: ManageCampaignService,
    private localStorage: LocalStorageService,
    private userService: UsersService,
    private modalService: NgbModal
  ) { 
     this.isAdmin = this.localStorage.checkFullAccessForTableList(
      this.localStorage.getRole()
    );
  }

  // Maps each report slug to the column that the report is about, so it can be
  // surfaced as the first column of the table.
  private readonly primaryColumnBySlug: { [slug: string]: string } = {
    'campaigns-by-status': 'status',
    'campaign-type': 'campaign_type',
    'scheduled-campaigns': 'schedule_date',
  };

  private applyPrimaryColumnOrder(): void {
    const primaryColumn = this.primaryColumnBySlug[this.slug];
    if (!primaryColumn) {
      return;
    }
    const columns = [...this.displayedColumns];
    const primaryIndex = columns.indexOf(primaryColumn);
    if (primaryIndex === -1) {
      return;
    }
    columns.splice(primaryIndex, 1);
    columns.unshift(primaryColumn);
    this.displayedColumns = columns;
  }

  ngAfterViewInit(): void {
    this.route.paramMap.subscribe(params => {
      this.slug = params.get('slug') || '';
    });

    switch (this.slug) {
      case 'campaigns-by-status':
        this.title = "Campaigns by Status";
        this.getCampaignsByStatus();
        break;
      case 'campaign-type':
        this.title = "Campaign Type";
        this.getCampaignsByType();
        break;
      case 'scheduled-campaigns':
        this.title = "Scheduled Campaigns";
        this.getScheduledCampaigns();
        break;
      default:
        this.title = "Campaign Report";
    }

    this.applyPrimaryColumnOrder();


    const today = new Date();
    const day = 24 * 60 * 60 * 1000; // one day in milliseconds
    const startOfWeek = (date: Date) => {
      const d = new Date(date);
      const diff = d.getDate() - d.getDay(); // Sunday as start of week
      return new Date(d.setDate(diff));
    };
    const endOfWeek = (date: Date) => {
      const d = startOfWeek(date);
      return new Date(d.getTime() + 6 * day);
    };
    const startOfMonth = (date: Date) => new Date(date.getFullYear(), date.getMonth(), 1);
    const endOfMonth = (date: Date) => new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const startOfQuarter = (date: Date) => new Date(date.getFullYear(), Math.floor(date.getMonth() / 3) * 3, 1);
    const endOfQuarter = (date: Date) => new Date(date.getFullYear(), Math.floor(date.getMonth() / 3) * 3 + 3, 0);
    const startOfYear = (date: Date) => new Date(date.getFullYear(), 0, 1);
    const endOfYear = (date: Date) => new Date(date.getFullYear(), 11, 31);

    const addDays = (date: Date, days: number) => new Date(date.getTime() + days * day);

    this.todaysFilter = [
      { label: "Today", value: "today", start_date: today, end_date: today },
      { label: "Yesterday", value: "yesterday", start_date: addDays(today, -1), end_date: addDays(today, -1) },
      { label: "Last 3 Days", value: "last_3_days", start_date: addDays(today, -2), end_date: today },
      { label: "Last 7 Days", value: "last_7_days", start_date: addDays(today, -6), end_date: today },
      { label: "Last 14 Days", value: "last_14_days", start_date: addDays(today, -13), end_date: today },
      { label: "Last 21 Days", value: "last_21_days", start_date: addDays(today, -20), end_date: today },
      { label: "Last 30 Days", value: "last_30_days", start_date: addDays(today, -29), end_date: today },
      { label: "This Week", value: "this_week", start_date: startOfWeek(today), end_date: endOfWeek(today) },
      { label: "Last Week", value: "last_week", start_date: addDays(startOfWeek(today), -7), end_date: addDays(endOfWeek(today), -7) },
      { label: "This Quarter", value: "this_quarter", start_date: startOfQuarter(today), end_date: endOfQuarter(today) },
      { label: "Last Quarter", value: "last_quarter", start_date: addDays(startOfQuarter(today), -90), end_date: addDays(startOfQuarter(today), -1) },
      { label: "This Month", value: "this_month", start_date: startOfMonth(today), end_date: endOfMonth(today) },
      { label: "Last Month", value: "last_month", start_date: new Date(today.getFullYear(), today.getMonth() - 1, 1), end_date: new Date(today.getFullYear(), today.getMonth(), 0) },
      { label: "This Year", value: "this_year", start_date: startOfYear(today), end_date: endOfYear(today) },
      { label: "Last Year", value: "last_year", start_date: new Date(today.getFullYear() - 1, 0, 1), end_date: new Date(today.getFullYear() - 1, 11, 31) },
    ];

  }

  
  getCampaignsByStatus() {
    try {
      merge(
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            this.isDataLoading = true;

            let param: any = {
              "where": {
                "client_id": this.localStorage.getClientId(),
                "status": this.selectedCampaignStatus,
              },
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              "order": {
                "col": "\"campaign\".\"updatedAt\"",
                "dir": "DESC"
              }
            };

            if(!this.isAdmin) {
              param.where.user_id = this.localStorage.getUserId();
            }
            

            return this.api
              .getAllManangeCampaign(param)
              .pipe(
                catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              this.isDataLoading = false;
              return [];
            }
            this.totalRows = response.count;
            return response;
          })
        )
        .subscribe({
          next: (data) => {

            this.dataSource = new MatTableDataSource<any>(data.rows);

            this.isDataLoading = false;
          },
          error: (e) => {

            this.isDataLoading = false;
            console.error(e);
          },
          complete: () => { },
        });
    } catch (e) {
      this.isDataLoading = false;
      this.initialLoad = false;
      console.error(e);
    }
  }

  getCampaignsByType() {
    try {
      merge(
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            this.isDataLoading = true;

            let param: any = {
              "where": {
                "client_id": this.localStorage.getClientId(),
                "campaign_type": this.selectedCampaignType?.map((type: string) => type.toLowerCase()),
              },
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              "order": {
                "col": "\"campaign\".\"updatedAt\"",
                "dir": "DESC"
              }
            };

            if (!this.isAdmin) {
              param.where.user_id = this.localStorage.getUserId();
            }

            return this.api
              .getAllManangeCampaign(param)
              .pipe(
                catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              this.isDataLoading = false;
              return [];
            }
            this.totalRows = response.count;
            return response;
          })
        )
        .subscribe({
          next: (data) => {

            this.dataSource = new MatTableDataSource<any>(data.rows);

            this.isDataLoading = false;
          },
          error: (e) => {

            this.isDataLoading = false;
            console.error(e);
          },
          complete: () => { },
        });
    } catch (e) {
      this.isDataLoading = false;
      this.initialLoad = false;
      console.error(e);
    }
  }

  getScheduledCampaigns() {
    try {
      merge(
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            this.isDataLoading = true;

            let param: any = {
              "where": {
                "client_id": this.localStorage.getClientId(),
                "status": "Schedule",
              },
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              "order": {
                "col": "\"campaign\".\"updatedAt\"",
                "dir": "DESC"
              }
            };

            if (!this.isAdmin) {
              param.where.user_id = this.localStorage.getUserId();
            }

            return this.api
              .getAllManangeCampaign(param)
              .pipe(
                catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              this.isDataLoading = false;
              return [];
            }
            this.totalRows = response.count;
            return response;
          })
        )
        .subscribe({
          next: (data) => {

            this.dataSource = new MatTableDataSource<any>(data.rows);

            this.isDataLoading = false;
          },
          error: (e) => {

            this.isDataLoading = false;
            console.error(e);
          },
          complete: () => { },
        });
    } catch (e) {
      this.isDataLoading = false;
      this.initialLoad = false;
      console.error(e);
    }
  }

  getAllLeadOwners() {
    try {

      let param = {
        client_id: this.localStorage.getClientId(),
      };

      this.userService.findAllUsers(param).subscribe({
        next: (data) => {
          this.ownerList = data;

          this.ownerList = this.ownerList.map((owner: any) => {
            return {
              user_id: owner.user_id,
              name: `${owner.fname} ${owner.lname}`,
            };
          });
        },
        error: (e) => {
          console.error(e);
        },
        complete: () => { },
      });
    } catch (e) {
      console.error(e);
    }
  }




  onTodaysFilterChange(event: any) {
    let selectedFilter = this.todaysFilter.find((filter) => filter.label === event);
    console.log(selectedFilter);
    this.startDate = selectedFilter.start_date;
    this.endDate = selectedFilter.end_date;
  }

  onFilterChange(event: any) {
    // this.selecteLeadStatusFilter = event;
    this.onTodaysFilterChange(this.selecteTodayFilter);
  }



  isSourceImage(source: string) {
    return isLeadSourceImage(source);
  }

  getLeadSourceImg(source: string) {
    return resolveLeadSourceImg(source);
  }

  openBulkFilter() {
    this.isOpen = true;
  }

  closeSidebar() {
    this.isOpen = false;
  }

  applyBulkFilter() {
    this.isOpen = false;
    if (this.slug == 'campaigns-by-status') {
      this.getCampaignsByStatus();
    } else if (this.slug == 'campaign-type') {
      this.getCampaignsByType();
    }
    else if (this.slug == 'scheduled-campaigns') {
      this.getScheduledCampaigns();
    }
  }
  clearFilter() {
    this.isOpen = false;
  }

  getOwnerName(owner: any) {
    if (owner && owner.fname && owner.lname) {
      return `${owner.fname} ${owner.lname}`;
    } else if (owner && owner.fname) {
      return owner.fname;
    } else if (owner && owner.lname) {
      return owner.lname;
    } else {
      return 'N/A';
    }
  }

  showDescription(content: any, ticket: any) {
    this.selectedTicketForActivity = ticket;

    console.log("selectedTicketForActivity", this.selectedTicketForActivity)
    this.modalService.open(content, {
      size: 'lg', scrollable: true,
      centered: true
    })
  }


  isImage(file: string): boolean {
    return /\.(jpg|jpeg|png|gif|webp)$/i.test(file);
  }

  // Check if the file is a video
  isVideo(file: string): boolean {
    return /\.(mp4|webm|ogg|mov)$/i.test(file);
  }

  // Get file name from the URL (optional, for display)
  getFileName(file: string): string {
    return file.split('/').pop() || 'Unknown File';
  }


  isPDF(file: string): boolean {
    return /\.(pdf)$/i.test(file);
  }
}


function observableOf(arg0: null): any {
  console.log(arg0);
  throw new Error('Function not implemented.');
}
